/**
 * @generated SignedSource<<b19efae839526e8ffb4577f6ae1df98f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesRouteData$data = {
  readonly syncedData: {
    readonly description: string | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesBlockSeriesData">;
  readonly " $fragmentType": "SeriesRouteData";
};
export type SeriesRouteData$key = {
  readonly " $data"?: SeriesRouteData$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesRouteData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesRouteData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SyncedSeriesData",
      "kind": "LinkedField",
      "name": "syncedData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeriesBlockSeriesData"
    }
  ],
  "type": "Series",
  "abstractKey": null
};

(node as any).hash = "a75312de5b85c17c49a0245f7c935183";

export default node;
